export default __webpack_public_path__ + "static/media/Ghost.af744795.png";